export const eduChangeApplyType = [
  {
    value: 1,
    label: '实验实践教学类'
  },
  {
    value: 2,
    label: '课程建设类'
  },
  {
    value: 3,
    label: '招标项目'
  }
]
